import React, { useState, useEffect } from 'react';
import './ISOCertificateButton.css';

const ISOCertificateButton = () => {
  const [showModal, setShowModal] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  // Scroll detection to hide/show button
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const threshold = 100; // Hide button after scrolling 100px
      
      if (scrollTop > threshold) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Security measures to prevent screenshots and downloads
  useEffect(() => {
    if (showModal) {
      // Disable right-click context menu
      const handleContextMenu = (e) => e.preventDefault();
      
      // Disable keyboard shortcuts for screenshots and downloads
      const handleKeyDown = (e) => {
        // Prevent Ctrl+S, Ctrl+Shift+S, F12, Print Screen, etc.
        if (
          (e.ctrlKey && (e.key === 's' || e.key === 'S')) ||
          (e.ctrlKey && e.shiftKey && (e.key === 's' || e.key === 'S')) ||
          e.key === 'F12' ||
          e.key === 'PrintScreen' ||
          e.key === 'F11'
        ) {
          e.preventDefault();
          return false;
        }
      };

      // Disable text selection
      const handleSelectStart = (e) => e.preventDefault();
      
      // Disable drag and drop
      const handleDragStart = (e) => e.preventDefault();

      document.addEventListener('contextmenu', handleContextMenu);
      document.addEventListener('keydown', handleKeyDown);
      document.addEventListener('selectstart', handleSelectStart);
      document.addEventListener('dragstart', handleDragStart);

      // Add CSS to prevent screenshots
      document.body.style.userSelect = 'none';
      document.body.style.webkitUserSelect = 'none';
      document.body.style.mozUserSelect = 'none';
      document.body.style.msUserSelect = 'none';

      return () => {
        document.removeEventListener('contextmenu', handleContextMenu);
        document.removeEventListener('keydown', handleKeyDown);
        document.removeEventListener('selectstart', handleSelectStart);
        document.removeEventListener('dragstart', handleDragStart);
        
        // Restore user selection
        document.body.style.userSelect = '';
        document.body.style.webkitUserSelect = '';
        document.body.style.mozUserSelect = '';
        document.body.style.msUserSelect = '';
      };
    }
  }, [showModal]);

  const handleISOClick = () => {
    setShowModal(true);
    setIsFullScreen(false);
  };

  const closeModal = () => {
    setShowModal(false);
    setIsFullScreen(false);
  };

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  return (
    <>
      {isVisible && (
        <div className="iso-certificate-button" onClick={handleISOClick}>
          <div className="iso-logo">
            <img src="/iso.png" alt="ISO 9001:2015 Certification" />
          </div>
        </div>
      )}

      {showModal && (
        <div className={`iso-modal-overlay ${isFullScreen ? 'fullscreen' : ''}`} onClick={closeModal}>
          <div className={`iso-modal ${isFullScreen ? 'fullscreen' : ''}`} onClick={(e) => e.stopPropagation()}>
            <div className="iso-modal-header">
              <h3>ISO Certificate</h3>
              <div className="iso-modal-controls">
                <button 
                  className="iso-view-button" 
                  onClick={toggleFullScreen}
                  title={isFullScreen ? "Small View" : "Full Screen"}
                >
                  {isFullScreen ? "⤓" : "⤢"}
                </button>
                <button className="iso-modal-close" onClick={closeModal}>×</button>
              </div>
            </div>
            <div className="iso-modal-content">
              <div className="pdf-security-notice">
                <p>⚠️ This document is protected. Screenshots and downloads are disabled.</p>
              </div>
              <div className="iso-image-container">
                <img
                  src="/documents/ISO.jpg"
                  alt="ISO 9001:2015 Certificate"
                  className={`iso-certificate-image ${isFullScreen ? 'fullscreen' : ''}`}
                  draggable="false"
                  onContextMenu={(e) => e.preventDefault()}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ISOCertificateButton;
